import { render, staticRenderFns } from "./biddingPlanAdd.vue?vue&type=template&id=710d5ea8&scoped=true"
import script from "./biddingPlanAdd.vue?vue&type=script&lang=js"
export * from "./biddingPlanAdd.vue?vue&type=script&lang=js"
import style0 from "./biddingPlanAdd.vue?vue&type=style&index=0&id=710d5ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d5ea8",
  null
  
)

export default component.exports